/**
 * @file autoActions.js
 * @location src/store/reducers/autoActions.js
 * @role 자동 처리 액션 핸들러 (App 마운트 시 1회 housekeeping)
 *
 *  AUTO_CARRY_OVER          미완료·기한 경과 task 의 due 를 다음날로 (주말 포함·수령 razor: 미수령 제외)
 *  AUTO_GENERATE_RECURRING  반복 업무 오늘 발생분 자동 생성·할당 (수령 대기 직행, 멱등)
 *
 * ※ 인계(delegation) 액션(DELEGATE_BULK/END_DELEGATION/AUTO_END_EXPIRED_DELEGATIONS)은
 *   razor 폐기로 제거. 신청(품의) razor 폐기로 구 approvalActions 도 이미 제거됨.
 *
 *  ⚠️ 온라인 모드에선 서버(pg_cron + generate-recurring Edge Function)가 권위 — 이 리듀서는
 *  오프라인/VITE_E2E 로컬 폴백. 생성 규칙은 utils/recurrence.js 이고, 서버는 동일 로직을
 *  supabase/functions/_shared/recurrence.ts 로 공유(tests/recurrence-parity.test.js 가 일치 강제).
 */
import { isClosed } from '../../data/labels.js';
import { getTodayStr, addDays } from '../../utils/dateUtils.js';
import { generateDueTasks } from '../../utils/recurrence.js';

export const autoActions = {
  AUTO_CARRY_OVER: (state) => {
    const today = getTodayStr();
    const newDue = addDays(today, 1);   // 다음날(주말 포함) — 영업일 스킵 없음
    return {
      ...state,
      tasks: state.tasks.map(t => {
        if (!t.due || t.due >= today) return t;
        if (isClosed(t.status)) return t;
        // razor: 수령(승인) 안 한 업무는 자동 이월 대상 외 — 받음 razor 정합.
        // 미수령 상태로 overdue 가 유지되면 독촉·정체 razor 가 강화 (수령 razor 5계층).
        if (!t.acknowledgedAt) return t;
        return { ...t, due: newDue };
      }),
    };
  },
  AUTO_GENERATE_RECURRING: (state) => {
    const today = getTodayStr();
    const { newTasks, updatedTemplates } = generateDueTasks(
      state.taskTemplates ?? [], state.tasks, today, state.uid,
    );
    // newTasks 가 없어도 active 템플릿의 lastGenDate 가 today 로 갱신됐으면 반영해야
    // 다음 마운트부터 start=today 라 백필 순회가 0건이 된다(하루 첫 마운트만 변화 → 이후 참조 유지).
    const prev = state.taskTemplates ?? [];
    const templatesChanged = updatedTemplates.some((t, i) => t.lastGenDate !== prev[i]?.lastGenDate);
    if (newTasks.length === 0 && !templatesChanged) return state;   // 변화 없으면 참조 유지 (재저장 방지)
    return { ...state, tasks: [...state.tasks, ...newTasks], taskTemplates: updatedTemplates };
  },
};
